import React from 'react';
import './Header.css';

export const Header = () => {
  return <h1>Happy feed</h1>
}